/** Fetches England & Wales bank holidays from the official Gov.uk API, cached for the session. */
let cache = null;
export async function getUKBankHolidays() {
    if (cache)
        return cache;
    try {
        const res = await fetch('https://www.gov.uk/bank-holidays.json');
        const data = await res.json();
        const events = data['england-and-wales']?.events ?? [];
        cache = new Set(events.map((e) => e.date));
        return cache;
    }
    catch {
        return cache ?? new Set();
    }
}
